"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unauthenticatedUserService = void 0;
const query_client_1 = require("../query-client");
const unauthenticated_user_service_1 = require("./unauthenticated-user-service");
exports.unauthenticatedUserService = new unauthenticated_user_service_1.UnauthenticatedUserService({
    resource: 'user',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
